// packages import
import { Autocomplete, FormControl, ListItem, TextField } from "@mui/material";
import { FC, useRef } from "react";
import { Controller, useFormContext } from "react-hook-form";
// others
import { CASE_STATUS_OPTIONS } from "../../constants";
import { FormErrors, StatusAutocompleteProps } from "../../interfaceTypes";
import { menuHeight } from "../../theme/styleConstants";
import { titleize } from '../../utils';

export const StatusAutoComplete: FC<StatusAutocompleteProps> = ({ isClosed }) => {
  const { control, formState: { errors } } = useFormContext();
  const courtCustomError = errors["statusType"] as FormErrors['statusType']
  const autoComplete = useRef(null)

  return (
    <FormControl variant="outlined" fullWidth>
      <Controller
        name="statusType"
        control={control}
        render={({ field: { onChange, value }, fieldState: { error: { message } = {} } }) => (
          <Autocomplete
            fullWidth
            value={value}
            disableClearable
            disabled={isClosed}
            options={CASE_STATUS_OPTIONS || []}
            ref={autoComplete}
            getOptionLabel={(value) => titleize(value?.label || "")}
            isOptionEqualToValue={(option, value) => option?.label === value?.label}
            onChange={(event, item) => {
              onChange(item)
            }}
            ListboxProps={menuHeight}
            renderOption={(props, option, index) => {
              const key = `listItem-${index}-${option?.id}`;

              return (
                <ListItem {...props} key={key}>
                  {titleize(option?.label)}
                </ListItem>
              );
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                error={!!courtCustomError?.id?.message || !!message}
                helperText={courtCustomError?.id?.message || message || ''}
                label="Status"
              />
            )}
          />
        )}
      />
    </FormControl>
  )
}